module.exports = __webpack_public_path__ + "static/media/part-01.00d46258.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-01.jpg
// module id = 940
// module chunks = 0